/** Reviewed first-party addresses; listing metadata cannot choose an embed URL. */
export const LAST_FISHERMAN = Object.freeze({
 id:'original-the-last-fisherman',slug:'the-last-fisherman',title:'The Last Fisherman',
 provider:'crateship-original',collection:'crateship-originals',
 contentUrl:'https://crateship-originals.pages.dev/the-last-fisherman/index.html',
 version:'original-last-fisherman-2026-10-09',
});

export function originalGame(row){
 if(row?.id!==LAST_FISHERMAN.id||row.slug!==LAST_FISHERMAN.slug||row.status!=='published'||row.price_minor!==0)return null;
 let metadata;try{metadata=JSON.parse(row.metadata_json);}catch{return null;}
 return metadata.provider===LAST_FISHERMAN.provider&&metadata.collection===LAST_FISHERMAN.collection?LAST_FISHERMAN:null;
}
